module.exports = __webpack_public_path__ + "static/media/glob@about.b00c9953.png";